import { render, staticRenderFns } from "./NotificationDetail.vue?vue&type=template&id=18a0efa9&"
import script from "./NotificationDetail.vue?vue&type=script&lang=js&"
export * from "./NotificationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports